import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, QueryList, ViewChildren, Output, EventEmitter, OnDestroy, Renderer2, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DAO } from '../../modal/DAO'
import { MenuClickContext } from '../../modal/routing.models'
import _ from 'lodash';
import { ServiceLayer } from 'src/app/services/serviceLayer';
import { merge, fromEvent, Subscription, } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { QuestionAnswer, ResponseContainer } from 'src/app/modal/questionnaire.models';
import { Constants } from 'src/app/modal/ProjConstants.models';
import { PolicyContainerService } from '../../component/policy-container/policy-container.service';

declare var require: any
let jsonPathRef = require('jsonpath');
declare var jQuery: any;
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class menuComponent implements OnInit, OnDestroy, AfterViewInit {

  @Output() notifyParentForRollback: EventEmitter<string> = new EventEmitter<string>();
  public policyContainerService = inject(PolicyContainerService, { optional: true });
  public dotNumber: string = "";
  public accountName: string;
  public policyExpirationDate: Date;
  public policyEffectiveDate: Date
  private apiCallSubscription: Subscription;
  private saveAndSubmitClickListener?: () => void;
  private saveAndContineCompleteListener?: () => void;
  private isSaveAndSubmitButtonClicked: boolean = false;

  constructor(public dao: DAO, private messageService: MessageService, public serviceLayer: ServiceLayer, private eventRenderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.saveAndSubmitClickListener = this.eventRenderer.listen(
      document.querySelector(".header_menu_cls"),
      Constants.SAVE_AND_SUBMIT_CLICKED,
      (event) => {
        this.isSaveAndSubmitButtonClicked = true;
        event.detail.isUwValid = !this.showInvalidUw;
        event.detail.isProductValid = !this.showInvalidProduct;
      });
    this.saveAndContineCompleteListener = this.eventRenderer.listen(
      document.querySelector(".header_menu_cls"),
      Constants.SAVE_AND_CONTINUE_COMPLETED,
      (event: CustomEvent) => {
        this.onSaveAndContinueCompleted(event)
      }
    );
    this.apiCallSubscription = this.serviceLayer.dotSubmissionDetails.subscribe(
      (dotSubmissionDetails) => {
        if (!!dotSubmissionDetails) {
          this.SetDataonInfoBar(dotSubmissionDetails)
        }
      });
  }

  ngAfterViewInit(): void {
  }

  // menu click
  public async menuClick(page) {
    let menuClickContext: MenuClickContext = new MenuClickContext();
    menuClickContext.currentPageIsValid = true;
    menuClickContext.page = page;
    this.serviceLayer.menuClickBehavior.next(menuClickContext);
    if (!this.policyContainerService?.readonlyMode() && (this.dao.PolicyTemplate == 'AccountInfo' || this.dao.PolicyTemplate == 'uw' || this.dao.PolicyTemplate == 'vehicles' || this.dao.PolicyTemplate == 'driver' || this.dao.PolicyTemplate == 'product' || this.dao.PolicyTemplate == 'losshistory') && menuClickContext.currentPageDataChanged) {
      this.serviceLayer.resetCarsHttpResponse();
    }

    let result: any;
    let currentPageOrder = this.serviceLayer.getPageOrder(this.dao.PolicyTemplate);
    let finalSavePageOrder = this.serviceLayer.getPageOrder(this.dao.navigatePage);
    let clickedPage = this.serviceLayer.getPageOrder(page);
    if (clickedPage <= finalSavePageOrder || clickedPage < currentPageOrder) {
      if (this.policyContainerService?.readonlyMode()) {
        //Go to clicked page, ignore validation check
        this.dao.PolicyTemplate = page;
        this.dao.IsBackButtonClicked = false;
        this.setActiveMenu(page);
        window.scrollTo(0, 300);
        return false;
      }
      result = await this.serviceLayer.menuClick(menuClickContext);
      if (result) {
        this.dao.PolicyTemplate = page;
      }
    }
    return false;
  }

  // ========= On Reject =====================
  public onReject(type) {
    this.messageService.clear(type);
    this.dao.isClickFromMenu = false;
    document.body.style.pointerEvents = "visible";
  }
  // confirm Change============
  public async confirmChange() {
    this.messageService.clear();
    document.body.style.pointerEvents = "visible";
    this.notifyParentForRollback.emit(this.dao.PolicyTemplate);
    if (this.dao.PolicyTemplate == 'AccountInfo') {
      this.dao.businessAddressValidation = '';      
    }    

    this.dao.isClickFromMenu = true;
    this.dao.ClickedPageFromMenuPage = this.dao.clickedPage;

    if (this.dao.isEmptyListFromMenu) {
      if (this.dao.navigatePage != this.dao.finalSubmitPage) {
        let finalSavePageOrder = await this.serviceLayer.getPageOrder(this.dao.navigatePage);
        this.dao.navigatePage = this.serviceLayer.getPageNamebyOrder(finalSavePageOrder - 1);
      }
      this.dao.isEmptyListFromMenu = false;
      this.dao.isClickFromMenu = false;
    }

    this.dao.PolicyTemplate = this.dao.ClickedPageFromMenuPage;
    this.setActiveMenu();
    this.dao.IsBackButtonClicked = false;
  }

  public setActiveMenu(page = "") {
    let response = this.serviceLayer.setActiveMenu(page);
  }
  public async SetDataonInfoBar(apiResponse: ResponseContainer) {
    let getAccountInfoQuestionnaire = this.dao.DOTList.accountInfoQsnr;
    let accountNameQA = getAccountInfoQuestionnaire.findQuestion('accountName');
    if (!!accountNameQA)
    {
      this.accountName = getAccountInfoQuestionnaire.findQuestion('accountName').answer;
      if (!!!this.accountName)
      {
        if (!!accountNameQA.questionDefault && accountNameQA.questionDefault.length > 0 && !!accountNameQA.questionDefault[0].code  )
          this.accountName = accountNameQA.questionDefault[0].code;
      } 
    }
    
    this.dotNumber = this.dao.DOTList.dotQsnr?.findQuestion("accountDot")?.answer;
    try
    {
        let getPolicyExpirationDateAnswer = getAccountInfoQuestionnaire.findQuestion('policyExpirationDate').answer;
        if (!!getPolicyExpirationDateAnswer)
        this.policyExpirationDate = this.serviceLayer.getCorrectDate(getPolicyExpirationDateAnswer);
        var getPolicyEffectiveDateQuestionanswer = getAccountInfoQuestionnaire.findQuestion('policyEffectiveDate');
        if (!!getPolicyEffectiveDateQuestionanswer.answer)
        this.policyEffectiveDate =this.serviceLayer.getCorrectDate( getPolicyEffectiveDateQuestionanswer.answer);
    }
    catch(ex)
    {
        console.error(ex)
    }
    
  }

  private onSaveAndContinueCompleted = (event: any) => {
    const detail = event?.detail;
    const template = detail?.policyTemplate;
    const userEmail = this.dao?.userMail;

    if (Constants.TestUserEmails.includes(userEmail?.toLocaleLowerCase())) {
      return;
    }

    if (!!!this.dao.DOTList.hasDeclinedResponse()) {
      if (['vehicles', 'driver', 'product', 'application'].includes(template)) {
        const finalSavePageOrder = this.serviceLayer.getPageOrder(this.dao.navigatePage);

        const filteredQuestionnaire = this.dao.DOTList.questionnaire?.filter(q => {
          const qOrder = this.serviceLayer.getPageOrder(q.key);
          return qOrder <= finalSavePageOrder;
        });

        const dotList = {
          ...this.dao.DOTList,
          questionnaire: filteredQuestionnaire
        };

        this.serviceLayer.EvaluatePriorSubmission(dotList, template);
      }
    }

    this.serviceLayer.validateSubmittedData();
  };

  public ngOnDestroy(): void {
    if (!!this.apiCallSubscription) {
      this.apiCallSubscription.unsubscribe();
      this.apiCallSubscription = null;
    }
    if (this.saveAndSubmitClickListener) {
      this.saveAndSubmitClickListener();
    }
    if (this.saveAndContineCompleteListener) {
      this.saveAndContineCompleteListener();
    }
  }

  public get showInvalidUw(): boolean {
    let dotInfo = this.dao.DOTList;
    if (!this.isSaveAndSubmitButtonClicked || !!!dotInfo)
      return false;
    let areAllUWCargoQusValid = dotInfo.areAllUWCargoQuestionsAnswered();
    return !areAllUWCargoQusValid;
  }

  public get showInvalidProduct(): boolean {
    let dotInfo = this.dao.DOTList;
    if (!this.isSaveAndSubmitButtonClicked || !!!dotInfo)
      return false;
    let areAllProductTrailerInterchangeQusValid = dotInfo.areAllProductTrailerInterchangeQuestionsAnswered(this.serviceLayer);
    let areAllProductCargoQusValid = dotInfo.areAllProductCargoQuestionsAnswered();
    return !(areAllProductCargoQusValid && areAllProductTrailerInterchangeQusValid);
  }
}
